<!--  -->
<template>
  <div class="table_box">
    <div class="template_box">
      <div class="search_box">
        <el-select v-model="policyobj.platform_id" filterable placeholder="请选择策略平台">
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="policyobj.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input v-model="policyobj.strategy_no" style="width:200px;" placeholder="请输入策略编号" />
        <el-input v-model="policyobj.strategy_name" style="width:200px;" placeholder="请输入策略标题" />
        <el-button class="search" type="primary" style="margin:0" icon="el-icon-search" @click="searchr">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" style="margin:0" @click="resetclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addarcadestrategy">新增预览群发</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData.list"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >
      <!-- <el-table-column
        type="selection"
        width="55"
      /> -->
      <el-table-column
        align="center"
        width="160"
        prop="strategyPreviewNo"
        label="编号"
        fixed="left"
      />
      <el-table-column
        align="center"
        prop="platformStr"
        width="80"
        label="平台"
      />
      <el-table-column
        align="center"
        prop="strategyName"
        label="标题"
        width="150"
      />
      <el-table-column
        prop="userWheresText"
        label="发送群体"
        width="250"
        align="center"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.userWheresText" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sendSortText"
        label="发送顺序"
        width="120"
      />
      <el-table-column
        align="center"
        prop="sendHiText"
        width="120"
        label="定时发送时间"
      />
      <el-table-column
        align="center"
        prop="statusStr"
        label="状态"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status === 1" class="el-icon-success defaultr" />
          {{ scope.row.statusStr }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="creator"
        width="80"
        label="创建人"
      />

      <el-table-column
        align="center"
        prop="createdAt"
        width="170"
        label="创建时间"
      />
      <el-table-column
        align="center"
        label="操作"
        width="500"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small" @click="edit(scope.row.id)">编辑</el-button> -->
          <el-button type="primary" size="small" @click="bandclick(scope.row)">绑定公众号</el-button>
          <el-button type="warning" size="small" @click="unbindclick(scope.row)">绑定记录</el-button>
          <!--          <el-button type="success" size="small" @click="multiplexing(scope.row)">复用</el-button>-->
          <el-button type="info" size="small" @click="multiplexingone(scope.row)">编辑</el-button>
          <el-button type="primary" size="small" @click="sendHistory(scope.row)">发送记录</el-button>
          <el-button type="danger" size="small" @click="deleteaccount(scope.row.strategyPreviewNo)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <pagination-right
      :current-page="policyobj.page"
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="新增预览群发"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <Strategyfactory v-if="showr" />
    </el-dialog>

    <el-dialog
      title="绑定公众号"
      :visible.sync="dialogVisiblebind"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Bindofficialaccountdia ref="bindaccout" @closedialog="closedialog" @closeAndB="closeAndB" />
    </el-dialog>

    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisibleunbind"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Unbindofficialaccountdia ref="unbindaccout" @unbink="unbink" />
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="AandBdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <bandAandB ref="bandAandBview" @saveupdata="saveupdata" />
    </el-dialog>
  </div>
</template>

<script>
import {
  policylist,
  strategyList,
  strategyPlatform,
  deleteaccountitem,
  getstrategyPreview, strategyPreviewDelStrategy
} from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Strategyfactory from './components/Strategyfactory.vue'
import Bindofficialaccountdia from './components/Bindofficialaccountdia.vue'
import Unbindofficialaccountdia from './components/Unbindofficialaccountdia.vue'
import bandAandB from './components/bandAandB.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    Strategyfactory,
    Bindofficialaccountdia,
    Unbindofficialaccountdia,
    bandAandB
  },
  mixins: [convertToHump],
  data() {
    return {

      showr: false,
      customerarr: [],
      tableData: [],
      dialogVisible: false,
      dialogVisiblebind: false,
      dialogVisibleunbind: false,
      AandBdialogVisible: false,
      accoutarr: [],
      policyobj: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        strategy_type: null,
        strategy_no: null,
        strategy_name: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内策略'
      }, {
        value: 2,
        label: '我关联的策略'
      }]
    }
  },
  activated() {
    // this.getstrategyListr()
    this.getstrategyplatform()
    this.getstrategyPreview()
    // this.policyobj.strategy_no = this.$route.query.ids ? this.$route.query.ids : null
    if (this.$route.query.ids) {
      this.policyobj.strategy_no = this.$route.query.ids
    }
  },
  created() {
    // this.getstrategyListr()
    console.log(policylist, strategyList, deleteaccountitem)
    this.getstrategyplatform()
    this.getstrategyPreview()
    this.policyobj.strategy_no = this.$route.query.ids ? this.$route.query.ids : null
  },
  methods: {
    saveupdata() {
      this.AandBdialogVisible = false
      this.getstrategyPreview()
    },
    // 获取预览模式群发数据
    async getstrategyPreview() {
      const data = await getstrategyPreview(this.policyobj)
      this.tableData = this.convertToHump(data.data)
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = this.convertToHump(data.data.list)
    },
    // 分页
    fetchPageSize(e) {
      this.policyobj.pageSize = e
      this.getstrategyPreview()()
    },
    fetchCurrentPage(e) {
      this.policyobj.page = e
      this.getstrategyPreview()()
    },
    resetclick() {
      this.policyobj = {
        page: 1,
        pageSize: 10,
        platform_id: null,
        strategy_type: null,
        strategy_no: null,
        strategy_name: null,
        onlyMe: 2
      }
      this.getstrategyPreview()()
    },
    // 绑定公众号
    bandclick(item) {
      this.dialogVisiblebind = true
      console.log(item.platformId)
      if (item.platformId === 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bindaccout.send(item, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bindaccout.send(item)
        }, 400)
      }
    },
    // 查询绑定公众号列表
    unbindclick(item) {
      this.dialogVisibleunbind = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.unbindaccout.send(item.strategyPreviewNo, item.officialAccounts)
      }, 100)
    },
    addarcadestrategy() {
      // this.dialogVisible = true
      // this.showr = true
      this.$router.push({ path: '/addStrategyPreview' })
    },
    close() {
      this.dialogVisible = false
      this.showr = false
    },
    closedialog() {
      this.dialogVisiblebind = false
      this.getstrategyPreview()()
    },
    closeAndB(val, strategy_no, arrsw) {
      this.dialogVisiblebind = false
      this.AandBdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandAandBview.send(val, strategy_no, arrsw, 1)
      }, 100)
    },
    unbink() {
      this.dialogVisibleunbind = false
      this.getstrategyPreview()()
    },
    sendHistory(item) {
      this.$router.push({ path: '/strategyPreview/sendHistory', query: { item: item.strategyPreviewNo }}) // TODO
    },
    multiplexingone(item) {
      this.$router.push({ path: '/addStrategyPreview', query: { item: item.strategyPreviewNo, type: 0, platform_id: item.platformId }})
    },
    // 删除
    deleteaccount(id) {
      this.$confirm('确定要删除当前策略吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        strategyPreviewDelStrategy({
          strategy_preview_no: id
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getstrategyPreview()()
          } else {
            this.$message({
              type: 'error',
              message: `${'操作失败，请联系管理员'}`
            })
          }
        })
      })
    },
    searchr() {
      this.policyobj.page = 1
      this.getstrategyPreview()()
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.table_box{
  padding: 30px;
}
.template_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.template_input{
 width: 300px;
}
.search{
  margin-left: 20px;
}
.defaultr{
  color: #67C23A;
}
.search_box{
  display:flex;
  gap:10px;
}
</style>
